import { z } from "zod";

/**
 * One table this person belongs at — a tag, not a roster. Who else ends up at the
 * same table is derived where it is needed, from the room, rather than copied into
 * everybody's row.
 */
const ClusterMembershipSchema = z.object({
  lens: z.string(),
  name: z.string(),
  seatReason: z.string(),
});

export type ClusterMembership = z.output<typeof ClusterMembershipSchema>;

export const ClusterMembershipDataSchema = z.array(ClusterMembershipSchema);
